import { render, staticRenderFns } from "./ProjectInventorySkills.vue?vue&type=template&id=626910b6&scoped=true&"
import script from "./ProjectInventorySkills.vue?vue&type=script&lang=js&"
export * from "./ProjectInventorySkills.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInventorySkills.vue?vue&type=style&index=0&id=626910b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626910b6",
  null
  
)

export default component.exports